import { apiService } from "../../app.service";

export const complianceApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchCompliances: builder.query({
      query: (type) => ({
        url: "/user/compliance",
        params: { type },
      }),
      providesTags: ["compliances"],
    }),
    fetchComplianceById: builder.query({
      query: (id) => ({
        url: `/user/compliance/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "compliance", id: result._id }] : [],
    }),
    createCompliance: builder.mutation({
      query: (data) => ({
        url: "/user/compliance",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["compliances"],
    }),
    updateCompliance: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/compliance/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "compliance", id },
        "compliances",
      ],
    }),
    deleteCompliance: builder.mutation({
      query: (data) => ({
        url: "/user/compliance/" + data,
        method: "DELETE",
      }),
      invalidatesTags: ["compliances"],
    }),
    reorderCompliance: builder.mutation({
      query: ({ type, data }) => ({
        url: "/user/compliance/reorder/" + type,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["compliances"],
    }),
    fetchCompliancesWithSubmission: builder.query({
      query: (type) => ({
        url: "/user/compliance/submission",
        params: { type },
      }),
      providesTags: ["complianceSubmissions"],
    }),
    createComplianceSubmission: builder.mutation({
      query: (data) => ({
        url: "/user/complianceSubmission",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["complianceSubmissions"],
    }),
     // ===== DOCUMENTATION ENDPOINTS =====
    getDocumentation: builder.query({
      query: (type) => ({
        url: `/user/documentation/${type}`,
      }),
      providesTags: ["documentation"],
    }),
    getAllDocumentation: builder.query({
      query: () => ({
        url: `/user/documentation`,
      }),
      providesTags: ["documentation"],
    }),
    upsertDocumentation: builder.mutation({
      query: (data) => ({
        url: `/user/documentation`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["documentation"],
    }),
    deleteDocumentation: builder.mutation({
      query: (type) => ({
        url: `/user/documentation/${type}`,
        method: "DELETE",
      }),
      invalidatesTags: ["documentation"],
    }),
  }),
});

export const {
  useFetchCompliancesQuery,
  useFetchComplianceByIdQuery,
  useCreateComplianceMutation,
  useUpdateComplianceMutation,
  useDeleteComplianceMutation,
  useReorderComplianceMutation,
  useFetchCompliancesWithSubmissionQuery,
  useCreateComplianceSubmissionMutation,
  useGetDocumentationQuery,
  useGetAllDocumentationQuery,
  useUpsertDocumentationMutation,
  useDeleteDocumentationMutation,
} = complianceApi;
